"use strict";

import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator } from "../indicator/indicator";
import { LinkedList } from "../Utils/LinkedList";
export var WMA =
/*#__PURE__*/
function (_Indicator) {
  _inherits(WMA, _Indicator);

  function WMA(input) {
    var _this;

    _classCallCheck(this, WMA);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WMA).call(this, input));
    var period = input.period;
    var priceArray = input.values;
    _this.result = [];
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var data, denominator, result, i, next;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = new LinkedList();
              denominator = period * (period + 1) / 2;

            case 2:
              if (!true) {
                _context.next = 21;
                break;
              }

              if (!(data.length < period)) {
                _context.next = 11;
                break;
              }

              _context.t0 = data;
              _context.next = 7;
              return;

            case 7:
              _context.t1 = _context.sent;

              _context.t0.push.call(_context.t0, _context.t1);

              _context.next = 19;
              break;

            case 11:
              data.resetCursor();
              result = 0;

              for (i = 1; i <= period; i++) {
                result = result + data.next() * i / denominator;
              }

              _context.next = 16;
              return result;

            case 16:
              next = _context.sent;
              data.shift();
              data.push(next);

            case 19:
              _context.next = 2;
              break;

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    priceArray.forEach(function (tick, index) {
      var result = _this.generator.next(tick);

      if (result.value !== undefined) {
        _this.result.push(_this.format(result.value));
      }
    });
    return _this;
  } // STEP 5. REMOVE GET RESULT FUNCTION


  _createClass(WMA, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price).value;

      if (result !== undefined) {
        return this.format(result);
      }
    }
  }]);

  return WMA;
}(Indicator);
WMA.calculate = wma;
export function wma(input) {
  Indicator.reverseInputs(input);
  var result = new WMA(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}